import React from 'react'

const ArrowUpIcon = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M8 10L12 14L16 10' stroke='#1F2D27' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  )
}

export { ArrowUpIcon }
